// 商城接口统一以 HTTP 200 + 业务码返回结果，Spring Security 对 /api/app/**、/api/pc/** 全部放行，
// 因此登录失效不会体现为 HTTP 401，只能通过业务码或后端提示文案识别。
// 后端若改为返回 code 401（见 Result.unauthorized），此处的码值判断会优先生效，文案匹配作为过渡期兜底。
const AUTH_EXPIRED_CODE = 401
const AUTH_EXPIRED_TEXT = /登录状态已失效|登录已过期/

function isAuthExpired(body) {
  if (!body || typeof body !== 'object') return false
  if (body.code === 200) return false
  if (body.code === AUTH_EXPIRED_CODE) return true
  return AUTH_EXPIRED_TEXT.test(String(body.msg == null ? '' : body.msg))
}

module.exports = { AUTH_EXPIRED_CODE, isAuthExpired }
